import quoteRequest from './quote-request'

export default {
  getDraftQuotePrice: {
    method: 'post',
    url: '/client/quote/draft'
  },
  getQuoteDataEdit: {
    method: 'get',
    url: '/client/quote/data-edit/ID'
  },
  editStatus: {
    method: 'put',
    url: '/client/quote/update-status/ID'
  },
  editQuote: {
    method: 'put',
    url: '/client/quote/edit/ID'
  },
  approveStatusMarkup: {
    method: 'put',
    url: '/client/quote/ID/approve-markup'
  },
  rejectStatusMarkup: {
    method: 'put',
    url: '/client/quote/ID/reject-markup'
  },
  checkAllocationTrip: {
    method: 'post',
    url: '/client/quote/check-allocation-trip/ID'
  },
  create: {
    method: 'post',
    url: '/client/quote/create'
  },
  createQuoteByQuoteRequest: {
    method: 'post',
    url: '/client/quote/create-by-quote-request'
  },
  get: {
    method: 'post',
    url: '/client/quote'
  },
  detail: {
    method: 'get',
    url: '/client/quote/ID'
  },
  getQuotePrice: {
    method: 'get',
    url: '/client/quote/price/quoteRequestId'
  },
  find: {
    method: 'post',
    url: '/client/quote/find?key=KEY'
  },
  xlsx: {
    method: 'get',
    url: '/client/quote/excel/ID'
  },
  pdf: {
    method: 'get',
    url: '/client/quote/pdf/ID'
  },
  sendEmail: {
    method: 'get',
    url: '/client/quote/send-email-for-customer/ID'
  },
  delete: {
    method: 'delete',
    url: '/client/quote'
  },
  archive: {
    method: 'delete',
    url: '/client/quote/archive'
  },
  restore: {
    method: 'put',
    url: '/client/quote/restore'
  },
  customer: {
    method: 'get',
    url: '/client/quote/customer/customerId'
  },
  quoteRequest
}
